import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import api from "../lib/api";
import { FadeUp, Eyebrow } from "./Reveal";
import { Waveform } from "./AudioArt";

export default function Testimonials() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews/featured").then((r) => setReviews(r.data)).catch(() => {}); }, []);
  if (reviews.length === 0) return null;

  return (
    <section className="relative py-24 lg:py-32 bg-obsidian text-white overflow-hidden grain" data-testid="testimonials-section">
      <Waveform className="absolute inset-x-0 top-8 w-full h-32 opacity-25 pointer-events-none" strands={3} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <FadeUp>
          <Eyebrow>From the artists</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl leading-tight">
            Your favorite engineer — <span className="italic gold-gradient-text">in their words.</span>
          </h2>
        </FadeUp>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <FadeUp key={r.review_id} delay={i * 0.1} className={`glass-dark rounded-3xl p-7 flex flex-col ${i % 3 === 1 ? "lg:translate-y-8" : ""}`} data-testid={`testimonial-${r.review_id}`}>
              <Quote size={22} className="text-gold" />
              <p className="font-serif text-lg leading-relaxed mt-4 flex-1">"{r.text}"</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium">{r.client_name}</p>
                  <p className="text-[11px] font-mono uppercase tracking-widest text-white/40 mt-0.5">{r.service_name}</p>
                </div>
                <span className="flex gap-0.5">{Array.from({ length: r.rating }).map((_, k) => <Star key={k} size={12} className="text-gold" fill="currentColor" />)}</span>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
